define('user-view',['controller', 'tooltip-notifier'], function(controller, tooltipNotifier) {
	
	function onSubscribeButtonClick() {
		var button = $(this);
		var user_id = button.data('user-id');
		
		$.ajax({
			url: '/users/' + user_id + '/subscribe',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			$('.subscribe-user-button').hide();
			$('.unsubscribe-user-button').show();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Beim Abonnieren ist ein Fehler aufgetreten', xhr);
		});
	}
	
	function onUnsubscribeButtonClick() {
		var button = $(this);
		var user_id = button.data('user-id');
		
		$.ajax({
			url: '/users/' + user_id + '/unsubscribe',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			$('.subscribe-user-button').show();
			$('.unsubscribe-user-button').hide();
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Beim Nicht-mehr-Abonnieren ist ein Fehler aufgetreten', xhr);
		});
	}
	
	function onSortSelectChange() {
		controller.navigateTo($(this).prop('value'));
	}
	
	controller.on('users/view/posts', function() {
		$('#sort-select').change(onSortSelectChange);
		$('#sort-select').select2({
			minimumResultsForSearch: -1,
			width: 'none'
		});
	});
	
	controller.on('users/view', function() {
		$('#all-posts-view').hide();
		
		$('.subscribe-user-button').click(onSubscribeButtonClick);
		$('.unsubscribe-user-button').click(onUnsubscribeButtonClick);

		$('#show-unreached-achievements-button').click(function() {
			var button = $(this);
			var achievementTable = $('.achievement-table');
			achievementTable.toggleClass('show-unreached');
			if (achievementTable.hasClass('show-unreached'))
				button.text("Unerreichte Auszeichnungen ausblenden");
			else
				button.text("Erreichbare Auszeichnungen einblenden");

		});
		
		$('#toggle-view').click(function() {
			if($('#all-posts-view').is(':visible')) {
				$('#all-posts-view').hide();
				$('#tag-view').show();
			} 
			else {
				$('#tag-view').hide();
				$('#all-posts-view').show();
			}
		});
	});
});

